'use strict';

require("core-js/modules/es.typed-array.set.js");

require("core-js/modules/es.typed-array.sort.js");

require("core-js/modules/es.typed-array.set.js");

require("core-js/modules/es.typed-array.sort.js");

var jwt_decode = require('jwt-decode');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}

var jwt_decode__default = /*#__PURE__*/_interopDefault(jwt_decode);
/*! @carvana/core-datadog v2.0.1 - Fri Oct 20 2023 17:08:50 GMT+0000 (Coordinated Universal Time) */


var merge = function (obj, defaultObj) {
  if (defaultObj === void 0) {
    defaultObj = {};
  }

  const mergedObj = { ...defaultObj,
    ...obj
  };

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      if (typeof obj[key] === "boolean") {
        mergedObj[key] = obj[key];
      }
    }
  }

  return mergedObj;
};

var sampling = (inputArray, sampleRate) => {
  if (sampleRate > 1 || sampleRate < 0) return inputArray;
  const sampleSize = Math.floor(inputArray.length * sampleRate);
  const sampledItems = [];
  const usedIndices = new Set();

  while (sampledItems.length < sampleSize) {
    const randomIndex = Math.floor(Math.random() * inputArray.length);

    if (!usedIndices.has(randomIndex)) {
      usedIndices.add(randomIndex);
      sampledItems.push(inputArray[randomIndex]);
    }
  }

  return sampledItems;
};

var sessionManager = (() => {
  const _sessionManager = {
    sessionId: "",
    viewId: ""
  };

  function setSession(_ref) {
    let {
      sessionId,
      viewId
    } = _ref;

    if (sessionId) {
      _sessionManager.sessionId = sessionId;
    }

    if (viewId) {
      _sessionManager.viewId = viewId;
    }
  }

  function getSession() {
    return _sessionManager || {};
  }

  function reset() {
    _sessionManager.sessionId = "";
    _sessionManager.viewId = "";
  }

  return {
    setSession,
    getSession,
    reset
  };
})();

var isSSR = () => {
  var _a;

  return !(typeof window !== "undefined" && ((_a = window.document) == null ? void 0 : _a.createElement));
};

var isFunction = fn => fn instanceof Function;

var getCookie = function (name, _temp) {
  let {
    cookieStore,
    req
  } = _temp === void 0 ? {} : _temp;

  try {
    if (cookieStore && isFunction(cookieStore)) {
      return cookieStore().get(name);
    }

    const cookieString = req ? req.headers.cookie : !isSSR() && document.cookie;
    const cookies = cookieString ? cookieString.split("; ").reduce((accumulator, currentCookie) => {
      const [key, value] = currentCookie.split("=");
      accumulator[key] = value;
      return accumulator;
    }, {}) : {};
    return cookies[name];
  } catch (error) {
    return "";
  }
};

var getLocalStorage = key => {
  try {
    const itemStr = localStorage.getItem(key);

    if (!itemStr) {
      return null;
    }

    const item = JSON.parse(itemStr);
    const now = new Date().getTime();

    if (now > item.expiration) {
      localStorage.removeItem(key);
      return null;
    }

    return item.value;
  } catch (error) {
    return localStorage.getItem(key);
  }
};

var setLocalStorage = (key, value, exp) => {
  try {
    const date = new Date();
    date.setTime(date.getTime() + convertToMilliseconds(exp));
    const expiration = date.getTime();
    const item = {
      value,
      expiration
    };
    localStorage.setItem(key, JSON.stringify(item));
  } catch (error) {
    localStorage.setItem(key, value);
  }
};

var convertToMilliseconds = input => {
  if (input === 0 || input === -1) {
    return input;
  }

  const regex = /^(\d+)([a-zA-Z]+)$/;
  const match = input.match(regex);

  if (!match) {
    return 0;
  }

  const value = parseInt(match[1], 10);
  const unit = match[2].toLowerCase();

  switch (unit) {
    case "d":
      return value * 24 * 60 * 60 * 1e3;

    case "h":
      return value * 60 * 60 * 1e3;

    case "m":
      return value * 60 * 1e3;

    case "s":
      return value * 1e3;

    case "ms":
      return value;

    default:
      return 0;
  }
};

var uuidv4 = () => {
  if (isSSR()) return uuidSSR();
  const array = new Uint8Array(16);
  window.crypto.getRandomValues(array);
  array[6] = array[6] & 15 | 64;
  array[8] = array[8] & 63 | 128;
  const hexArray = Array.from(array, byte => ("0" + byte.toString(16)).slice(-2));
  return hexArray.slice(0, 4).join("") + "-" + hexArray.slice(4, 6).join("") + "-" + hexArray.slice(6, 8).join("") + "-" + hexArray.slice(8, 10).join("") + "-" + hexArray.slice(10, 16).join("");
};

var uuidSSR = function (a) {
  if (a === void 0) {
    a = "";
  }

  return a ? ((Number(a) ^ Math.random() * 16) >> Number(a) / 4).toString(16) : (1e7 + "-" + 1e3 + "-" + 4e3 + "-" + 8e3 + "-" + 1e11).replace(/[018]/g, uuidSSR);
};

var RequestInterceptor = class {
  constructor(url) {
    this.url = url;
    this.intercept();
  }

  intercept() {
    const originalFetch = window.fetch;

    window.fetch = (input, init) => {
      var _a;

      if (typeof input === "string" && input.startsWith(this.url) && (init == null ? void 0 : init.method) === "POST") {
        try {
          const sessions = [];

          if (init && typeof init.body === "string") {
            (_a = init == null ? void 0 : init.body) == null ? void 0 : _a.split("\n").forEach(item => {
              sessions.push(JSON.parse(item));
            });
            const {
              session,
              view
            } = sessions[sessions.length - 1] || {};
            sessionManager.setSession({
              sessionId: session == null ? void 0 : session.id,
              viewId: view == null ? void 0 : view.id
            });
          }
        } catch (error) {
          console.error(error);
        }
      }

      return originalFetch(input, init);
    };
  }

};
var navigationStart;

function getNavigationStart() {
  var _a;

  if (navigationStart === void 0) {
    navigationStart = (_a = performance == null ? void 0 : performance.timing) == null ? void 0 : _a.navigationStart;
  }

  return navigationStart;
}

function addDuration(a, b) {
  return a + b;
}

function currentDrift() {
  return Math.round(new Date().getTime() - addDuration(getNavigationStart(), performance.now()));
}

var decodeJWT = token => {
  try {
    return jwt_decode__default.default(token);
  } catch (error) {
    console.error("Error decoding JWT:", error);
    return {};
  }
};

var decodeCookie = accessToken => {
  try {
    if (!accessToken) return {};
    const jwt = decodeJWT(accessToken);
    return jwt;
  } catch (error) {
    return {};
  }
};

var defaultOpts = {
  batchSize: 20,
  maxInterval: 25001,
  sampleRate: 1,
  byPassSessionManager: false
};
var DataDog = class {
  constructor(opts) {
    this.opts = opts;
    this.batch = [];
    this.timer = null;
    this.sessionId = null;
    this.viewId = null;
    this.userId = null;
    this.sessionManagerRetries = 0;
    this.opts = merge(opts, defaultOpts);
    let sessionId = getLocalStorage("dd_rum_session_id");

    if (!sessionId) {
      sessionId = uuidv4();
      setLocalStorage("dd_rum_session_id", sessionId, "4h");
    }

    this.sessionId = sessionId;
    this.viewId = uuidv4();
    ["unload", "visibilitychange"].forEach(event => {
      window.addEventListener(event, () => this.sendBatch(true));
    });
    new RequestInterceptor("https://rum.browser-intake-datadoghq.com/api/v2/rum");
  }

  add(name, context) {
    var _a;

    try {
      const data = {
        _dd: {
          format_version: 2,
          drift: currentDrift(),
          session: {
            plan: 1
          }
        },
        application: {
          id: this.opts.applicationId
        },
        date: new Date().getTime(),
        service: this.opts.service,
        version: this.opts.version,
        source: "browser",
        session: {
          id: this.sessionId,
          type: "user"
        },
        view: {
          id: this.viewId,
          url: window.location.href,
          referrer: document.referrer
        },
        action: {
          id: uuidv4(),
          target: {
            name
          },
          type: "custom"
        },
        type: "action",
        context,
        usr: {
          id: getCookie("BrowserCookieId"),
          userId: this.userId || ((_a = decodeCookie(getCookie("CVIdToken") || "")) == null ? void 0 : _a.user_id)
        }
      };
      this.batch.push(data);

      if (this.batch.length >= this.opts.batchSize) {
        this.sendBatch();
      } else {
        this.startTimer();
      }
    } catch (error) {}
  }

  setUserId(userId) {
    this.userId = userId;
  }

  removeUserId() {
    this.userId = null;
  }

  sendBatch(bypass) {
    if (bypass === void 0) {
      bypass = false;
    }

    try {
      const {
        sessionId,
        viewId
      } = this.opts.byPassSessionManager ? {
        sessionId: this.sessionId,
        viewId: this.viewId
      } : sessionManager.getSession();

      if (!this.opts.byPassSessionManager && !sessionId && !viewId && this.sessionManagerRetries <= 3 && !bypass) {
        this.sessionManagerRetries += 1;
        this.clearTimer();
        this.startTimer();
        return;
      }

      if (this.batch.length > 0) {
        const fakeSdkVersion = "4.34.3";
        const tags = ["sdk_version:" + fakeSdkVersion, "api:fetch", "env:" + this.opts.environment, "service:" + this.opts.service];
        const parameters = ["ddsource=browser", "ddtags=" + encodeURIComponent(tags.join(",")), "version=" + encodeURIComponent(this.opts.version), "dd-api-key=" + this.opts.clientToken, "dd-evp-origin-version=" + encodeURIComponent(fakeSdkVersion), "dd-evp-origin=browser", "dd-request-id=" + uuidv4(), "batch_time=" + new Date().getTime()];
        let data = "";
        const sampled = sampling(this.batch.filter(x => {
          var _a;

          return ((_a = x == null ? void 0 : x.context) == null ? void 0 : _a.type) !== "error";
        }), this.opts.sampleRate);

        for (const batch of this.batch) {
          const discarded = !sampled.includes(batch);
          if (discarded) batch._dd.discarded = true;
          if (sessionId) batch.session.id = sessionId;
          if (viewId) batch.view.id = viewId;
          data += JSON.stringify(batch) + "\n";
        }

        navigator.sendBeacon("https://rum.browser-intake-datadoghq.com/api/v2/rum?" + parameters.join("&"), data);
        this.batch = [];
        this.clearTimer();
        this.sessionManagerRetries = 0;
      }
    } catch (error) {}
  }

  startTimer() {
    if (!this.timer) {
      this.timer = setTimeout(() => {
        this.sendBatch();
      }, this.opts.maxInterval);
    }
  }

  clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

};
var Logger = class {
  constructor(_ref2) {
    let {
      service,
      applicationId,
      clientToken,
      isLocalInstance,
      environment = "development",
      version = "0.0.0",
      disableLogger = false,
      ...rest
    } = _ref2;
    this.context = {};
    this.isLocalInstance = false;
    this.disableLogger = false;
    this.ddRum = null;
    this.service = "";
    this.isLocalInstance = isLocalInstance || false;
    this.service = service;
    this.disableLogger = disableLogger;
    this.ddRum = new DataDog({ ...rest,
      applicationId,
      clientToken,
      service,
      environment,
      version
    });
  }

  setContext(data) {
    this.context = { ...this.context,
      ...data
    };
  }

  setUserId(userId) {
    var _a;

    (_a = this.ddRum) == null ? void 0 : _a.setUserId(userId);
  }

  removeUserId() {
    var _a;

    (_a = this.ddRum) == null ? void 0 : _a.removeUserId();
  }

  info(name, context) {
    if (context === void 0) {
      context = {};
    }

    this.log(name, "info", context);
  }

  start(name, context) {
    if (context === void 0) {
      context = {};
    }

    this.log(name, "start", context);
  }

  error(name, context) {
    if (context === void 0) {
      context = {};
    }

    this.log(name, "error", context);
  }

  success(name, context) {
    if (context === void 0) {
      context = {};
    }

    this.log(name, "success", context);
  }

  aborted(name, context) {
    if (context === void 0) {
      context = {};
    }

    this.log(name, "aborted", context);
  }

  log(name, type, context) {
    if (context === void 0) {
      context = {};
    }

    var _a;

    const data = { ...this.context,
      type,
      ...context
    };

    if (context.error) {
      const err = context.error;
      data.error = err instanceof Error ? err.message : String(err);
    }

    if (!this.disableLogger) {
      if (this.isLocalInstance) {
        console.log.bind(console, "[datadog-" + this.service + "]:")(name, data);
      } else {
        (_a = this.ddRum) == null ? void 0 : _a.add(name, data);
      }
    }
  }

};
exports.Logger = Logger;